import React, { useEffect, useState } from "react";
import styles from "./styles/length-slider.module.scss";
import { formatTime } from "@/utils/audio-duration";
import { useTextToMusicContext } from "@/components/pages/text-to-music/components/providers/text-to-music-provider";
import { defaultMaxTtmsDuration } from "@/services/license/license-limiters/service-using-duration-limiters/text-to-music-duration-limiter";
import { textToMusicLicenseManager } from "@/services/license/license-managers/text-to-music-license-manager";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const LengthSlider = () => {
  const { settings, handleLengthChange } = useTextToMusicContext();
  const [value, setValue] = useState<number>(15);
  const { license, isLicenseFetched } = useProfileContext();
  const { showModal } = useGlobalModalContext();

  const showTextToMusicDurationLimitModal = () => {
    showModal({
      type: "text-to-music-duration-limited_modal",
      props: { licenseName: license },
    });
  };

  useEffect(() => {
    setValue(settings.trackLength ?? 15);
  }, [settings.trackLength]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const floatValue = parseFloat(event.target.value);
    if (license === "Trial" && isLicenseFetched && floatValue > 15) {
      showTextToMusicDurationLimitModal();
      setValue(15);
      return;
    }
    setValue(floatValue);
    handleLengthChange(floatValue);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header_wrapper}>
        <div className={styles.title}>Track Length</div>
        <div className={styles.description}>
          Adjust the duration of the generated music.
        </div>
      </div>
      <div className={styles.slider_wrapper}>
        <input
          className={styles.slider}
          type="range"
          min="1"
          max={defaultMaxTtmsDuration}
          step="1"
          value={value}
          onChange={handleChange}
          style={{
            background: `linear-gradient(
            to right,
            #FF5722 ${(value / defaultMaxTtmsDuration) * 100 - 1}%,
            #A5A5A5 ${(value / defaultMaxTtmsDuration) * 100 - 1}%
          )`,
          }}
        />
        <div className={styles.time}>{formatTime(value)}</div>
      </div>
    </div>
  );
};

export default LengthSlider;
